/**
 * Product Bundle Functions
 * Shopify Theme v2.0.1
 * 
 * Handles product bundles, combo offers, and related products
 * Required for: Product pages, Collection pages, Cart
 */

(function() {
    'use strict';
    
    // Bundle settings from theme config
    var bundleConfig = {
        maxItems: 4,
        showDiscount: true,
        enableCombo: true,
        discountLabel: 'Bundle Offer',
        enableRelated: true,
        relatedLimit: 6,
        enableUpsell: true
    };
    
    // Cache DOM elements for performance
    var bundleContainer = document.querySelector('.product-bundle-container');
    var bundleItems = document.querySelectorAll('.bundle-item');
    var comboSelectors = document.querySelectorAll('.combo-selector');
    var relatedProducts = document.querySelectorAll('.related-product');
    var upsellItems = document.querySelectorAll('.upsell-item');
    
    // Calculate bundle discount
    function calculateBundleDiscount(items) {
        var totalPrice = 0;
        var discountedPrice = 0;
        for (var i = 0; i < items.length; i++) {
            totalPrice += parseFloat(items[i].getAttribute('data-price')) || 0;
        }
        discountedPrice = totalPrice * 0.85;
        return {
            total: totalPrice,
            discounted: discountedPrice,
            savings: totalPrice - discountedPrice
        };
    }
    
    // Update bundle total when items change
    function updateBundleTotal() {
        var selectedItems = document.querySelectorAll('.bundle-item.selected');
        var totalElement = document.querySelector('.bundle-total');
        if (selectedItems.length && totalElement) {
            var discount = calculateBundleDiscount(selectedItems);
            totalElement.textContent = '$' + discount.discounted.toFixed(2);
            var savingsElement = document.querySelector('.bundle-savings');
            if (savingsElement) {
                savingsElement.textContent = 'Save $' + discount.savings.toFixed(2);
            }
        }
    }
    
    // Handle URL parameters for filtering
    function getUrlParams() {
        var params = {};
        var queryString = window.location.search.substring(1);
        var pairs = queryString.split('&');
        for (var i = 0; i < pairs.length; i++) {
            var pair = pairs[i].split('=');
            if (pair.length === 2) {
                params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
            }
        }
        return params;
    }
    
    function updateUrlParams(params) {
        var currentParams = getUrlParams();
        for (var key in params) {
            currentParams[key] = params[key];
        }
        var queryString = '';
        for (var key in currentParams) {
            if (currentParams[key]) {
                queryString += (queryString ? '&' : '?') + encodeURIComponent(key) + '=' + encodeURIComponent(currentParams[key]);
            }
        }
        window.history.pushState({}, '', window.location.pathname + queryString);
    }
    
    // Initialize bundle functionality
    function initBundle() {
        // Setup combo selectors
        if (comboSelectors.length) {
            comboSelectors.forEach(function(selector) {
                selector.addEventListener('click', function(e) {
                    e.preventDefault();
                    var comboId = this.getAttribute('data-combo');
                    var currentCombo = getUrlParams().combo;
                    if (currentCombo === comboId) {
                        delete getUrlParams().combo;
                        updateUrlParams({ combo: '' });
                    } else {
                        updateUrlParams({ combo: comboId });
                    }
                    window.location.reload();
                });
            });
        }
        
        // Setup bundle items selection
        if (bundleItems.length) {
            bundleItems.forEach(function(item) {
                item.addEventListener('click', function() {
                    this.classList.toggle('selected');
                    updateBundleTotal();
                });
            });
        }
        
        // Setup related products animation
        if (relatedProducts.length) {
            relatedProducts.forEach(function(product, index) {
                product.style.animationDelay = (index * 0.1) + 's';
            });
        }
        
        // Setup upsell items animation
        if (upsellItems.length) {
            upsellItems.forEach(function(item, index) {
                item.style.animationDelay = (index * 0.15) + 's';
            });
        }
        
        // Update bundle total on load
        updateBundleTotal();
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initBundle);
    } else {
        initBundle();
    }
    
})();